import Tool, { type IToolAvailableInput } from '../../tools/Tool';

class ToolWireframe extends Tool {
  static enabled({
    controller,
    selection,
  }: {
    controller: any;
    selection: any;
  }): boolean {
    if (!super.enabled({ controller, selection })) return false;

    if (selection.type === 'activeSelection') {
      return selection
        .getObjects()
        .every(object => object.type === 'wireframe');
    }
    return selection.type === 'wireframe';
  }

  static available({ controller, selection }: IToolAvailableInput) {
    if (!super.available({ controller, selection })) return false;

    if (selection?.type === 'activeSelection') {
      return selection
        .getObjects()
        .every(object => object.type === 'wireframe');
    }
    return selection?.type === 'wireframe';
  }
}

export default ToolWireframe;
